// External library imports
import * as yup from 'yup';
import moment from 'moment';
import { get as lodashGet } from 'lodash';
// Internal module imports
import { ERRORS } from '../../utils/validationHelper';

const validateNumber = () => yup.number().typeError(ERRORS.number).min(0).required(ERRORS.required);
const capacityValidate = () => yup.array().of(validateNumber());

const validatePrice = () => {
    return yup.array().of(
        yup
            .number()
            .required(ERRORS.required)
            .min(0)
            .test('price', 'Price should be greater than 0', (val, c) => {
                const idx = lodashGet(c, ['options', 'index']);
                if (lodashGet(c, ['from', 0, 'value', 'capacity', idx], 0) > 0 && val <= 0) return false;
                else if (lodashGet(c, ['from', 0, 'value', 'capacity', idx], 0) <= 0 && val !== 0) {
                    const { path, createError } = c;
                    return createError({
                        path,
                        message: 'Price should be 0',
                    });
                } else return true;
            })
    );
};

export const RequestBidValidation = (market, customBidding) =>
    yup.object().shape({
        capacity: customBidding ? capacityValidate() : yup.array().optional(),
        price: customBidding ? validatePrice() : yup.array().optional(),
        ...(market.includes('aFRR') || market.includes('mFRR') ? { regulationPrice: customBidding ? validatePrice() : yup.array().optional() } : {}),
        instanceId: yup.string().required(ERRORS.required),
        startDate: yup.date().required(ERRORS.required),
        endDate: yup
            .date()
            .required(ERRORS.required)
            .test('is-after-or-equal', "End date can't be before start date", (value, c) => {
                const startDate = c.resolve(yup.ref('startDate'));
                if (!value || !startDate) return false;
                const formattedValue = moment(value).startOf('day');
                const formattedStartDate = moment(startDate).startOf('day');
                return formattedValue.isSameOrAfter(formattedStartDate);
            }),
        note: yup.string().required(ERRORS.required),
        customBidding: yup.boolean().required(),
    });

export const MaintenanceHourValidationValidation = yup.object().shape({
    groupId: yup.string().required(ERRORS.required),
    date: yup.date().required(ERRORS.required),
    hours: yup
        .array()
        .of(yup.object().shape({ label: yup.string(), value: yup.number() }))
        .required()
        .min(1),
    note: yup.string().required(ERRORS.required),
});
